import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BcmContentReducer(state = initialState.bcmContent, action: any) {
  switch (action.type) {
    case types.SAVE_BCMCONTENT_SUCCESS:
      return action.bcmContent;
    default:
      return state;
  }
}
